<template>
  <v-expansion-panels v-model="panel" multiple>
    <v-expansion-panel elevation="0" rounded="lg">
      <v-expansion-panel-title height="48px" style="background-color: #7077bb4D">
        <span class="reg-normal">{{ $store.getters.translate('open_todo_items') }} ({{ todo_lists.filter(item => !item.closed).length }})</span>
        <template #actions="{ expanded }">
          <v-icon size="large" :icon="expanded ? 'mdi-chevron-up' : 'mdi-chevron-down'"/>
        </template>
      </v-expansion-panel-title>
      <v-expansion-panel-text>
        <v-list v-if="todo_lists.find(item => !item.closed)" density="compact">
          <template v-for="todolist in $lodash.sortBy(todo_lists.filter(item => !item.closed), 'project_management_id')">
            <v-list-item color="primary">
              <v-list-item-title>
                <v-chip v-if="source_page === 'home'" color="secondary" class="mb-3">
                  <span class="sm-bold text-subtle">{{ $store.getters.translate('project') + ': ' }}<span class="sm-normal text-subtle">{{ todolist.project_management_name }}</span></span>
                  <span v-if="todolist.tags" class="sm-bold text-subtle ml-5">{{ $store.getters.translate('tags') + ': ' }}<span class="sm-normal text-subtle">{{ todolist.tags.join (', ') }}</span></span>
                </v-chip>
                <div>
                  <span class="sm-normal text-primary">{{ todolist.name }}</span>
                </div>
              </v-list-item-title>
              <v-list-item-subtitle>
                <span class="tiny-normal">{{ getOpenTodolistText(todolist) }}</span>
              </v-list-item-subtitle>
              <template #append>
                <v-list-item-action>
                  <v-menu>
                    <template #activator="{ props }">
                      <v-btn elevation="0" icon v-bind="props">
                        <PhDotsThreeVertical size="24" style="cursor: pointer;"/>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="closeTodoList(todolist)">
                        <template #prepend><PhCheck size="24"/></template>
                        <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate('close') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="editTodoList(todolist)">
                        <template #prepend><PhPencilSimpleLine size="24"/></template>
                        <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate('edit') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="deleteTodoList(todolist)">
                        <template #prepend><PhTrash size="24"/></template>
                        <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate('delete') }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item-action>
              </template>
            </v-list-item>
            <v-divider class="mt-3 mb-3" />
          </template>
        </v-list>
        <div class="reg-normal text-primary mt-3" v-else>{{ $store.getters.translate("nothing_found") }}</div>
        <v-row class="mt-0">
          <v-col v-if="source_page === 'home'" cols="3">
            <v-autocomplete
                density="default"
                class="reg-normal text-primary"
                base-color="border-tertiary"
                bg-color="secondary"
                color="primary"
                v-model="record.project_management_id"
                :items="project_management"
                :return-object="false"
                item-value="value"
                item-title="text"
                hide-details
                clearable>
              <template #label>
                <span class="sm-normal text-subtle">{{ $store.getters.translate('project') }}<strong>*</strong></span>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="3">
            <v-text-field
                density="default"
                class="reg-normal text-primary"
                base-color="border-tertiary"
                bg-color="secondary"
                color="primary"
                v-model="record.due_date"
                v-mask="'##-##-####'"
                placeholder="dd-mm-yyyy"
                hide-details
                single-line
                flat
                clearable>
              <template #label>
                <span class="sm-normal text-subtle">{{ $store.getters.translate('due_date') }}</span>
              </template>
            </v-text-field>
          </v-col>
          <v-col>
            <v-text-field
                density="default"
                class="reg-normal text-primary"
                base-color="border-tertiary"
                bg-color="secondary"
                color="primary"
                v-model="record.name"
                @keyup.enter="insertContent()"
                hide-details
                single-line
                flat
                clearable>
              <template #label>
                <span class="sm-normal text-subtle">{{ $store.getters.translate('task') }}</span>
              </template>
              <template #append>
                <base-action-button @click="insertContent()">
                  <template #prepend><PhPlus style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate('add') }}
                </base-action-button>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </v-expansion-panel-text>
    </v-expansion-panel>
    <v-expansion-panel elevation="0" rounded="lg">
      <v-expansion-panel-title height="48px" style="background-color: #7077bb4D">
        <span class="reg-normal">{{ $store.getters.translate('closed_todo_items') }} ({{ todo_lists.filter(item => item.closed).length }})</span>
        <template #actions="{ expanded }">
          <v-icon size="large" :icon="expanded ? 'mdi-chevron-up' : 'mdi-chevron-down'"/>
        </template>
      </v-expansion-panel-title>
      <v-expansion-panel-text>
        <v-list v-if="todo_lists.find(item => item.closed)" density="compact">
          <template v-for="todolist in $lodash.sortBy(todo_lists.filter(item => item.closed), 'project_management_id')">
            <v-list-item color="primary">
              <v-list-item-title>
                <v-chip v-if="source_page === 'home'" color="secondary" class="mb-3">
                  <span class="sm-bold text-subtle">{{ $store.getters.translate('project') + ': ' }}<span class="sm-normal text-subtle">{{ todolist.project_management_name }}</span></span>
                  <span v-if="todolist.tags" class="sm-bold text-subtle ml-5">{{ $store.getters.translate('tags') + ': ' }}<span class="sm-normal text-subtle">{{ todolist.tags.join (', ') }}</span></span>
                </v-chip>
                <div>
                  <span class="sm-normal text-primary">{{ todolist.name }}</span>
                </div>
              </v-list-item-title>
              <v-list-item-subtitle>
                <span class="tiny-normal">{{ getClosedTodolistText(todolist) }}</span>
              </v-list-item-subtitle>
              <template #append>
                <v-list-item-action>
                  <v-menu>
                    <template #activator="{ props }">
                      <v-btn elevation="0" icon v-bind="props">
                        <PhDotsThreeVertical size="24" style="cursor: pointer;"/>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="deleteTodoList(todolist)">
                        <template #prepend><PhTrash size="24"/></template>
                        <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate('delete') }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item-action>
              </template>
            </v-list-item>
            <v-divider class="mt-3 mb-3" />
          </template>
        </v-list>
        <div class="reg-normal text-primary mt-3" v-else>{{ $store.getters.translate("nothing_found") }}</div>
      </v-expansion-panel-text>
    </v-expansion-panel>
  </v-expansion-panels>
  <edit-todolist ref="edit_todolist" :source_page="source_page" @refresh="getTodoLists"/>
</template>

<script>
import helpFunctions from "../../plugins/helpFunctions";
import BaseActionButton from "./BaseActionButton";
import EditTodolist from "../../views/todolists/Edit";
import {PhCheck, PhDotsThreeVertical, PhPencilSimpleLine, PhPlus, PhTrash} from "@phosphor-icons/vue";

export default {
  components: {EditTodolist, BaseActionButton, PhPencilSimpleLine, PhCheck, PhTrash, PhDotsThreeVertical, PhPlus },
  props: ["project_management_id", "source_page"],
  data() {
    return {
      page: helpFunctions.pages.todolists,
      record: {},
      todo_lists: [],
      project_management: [],
      panel: [0, 1]
    };
  },
  created() {
    this.load();
    if(this.source_page === 'home') {
      this.getProjectManagement();
    }
  },
  methods: {
    async load() {
      await this.getTodoLists();
    },
    async getTodoLists() {
      if(this.source_page === 'home') {
        this.todo_lists = await helpFunctions.getCustomRoute(this.$toast, this.page.name, true);
      }
      else {
        this.todo_lists = await helpFunctions.getCustomRoute(this.$toast, this.page.name + "?project_management_id=" + this.project_management_id, true);
      }
    },
    async getProjectManagement() {
      this.project_management = await helpFunctions.getAdditionalModelsForDropdowns("projectmanagement", "id", ["name"]);
    },
    async insertContent() {
      let usual_fields_required = [{name: 'name', mandatory: true}];
      if (helpFunctions.modelFieldsFilled(this.$toast, this.record, usual_fields_required)) {
        if(this.project_management_id) {
          this.record.project_management_id = this.project_management_id;
        }
        await helpFunctions.createModel(this.$toast, this.page.name, this.record);
        this.record = {};
        await this.getTodoLists();
      }
    },
    async closeTodoList(todo_list) {
      await helpFunctions.postCustomRoute(this.$toast, "close-todolist", { id: todo_list.id }, true, true);
      await this.getTodoLists();
    },
    editTodoList(todo_list) {
      this.$refs.edit_todolist.load(todo_list.id);
    },
    async deleteTodoList(todo_list) {
      this.$confirm(this.$store.getters.translate("delete_confirmation")).then(async (res) => {
        if (res) {
          await helpFunctions.deleteModel(this.$toast, this.page.name, todo_list.id);
          await this.getTodoLists();
        }
      });
    },
    getOpenTodolistText(todolist) {
      let text = todolist.creator;
      if(todolist.due_date) {
        text += ' due to ' + todolist.due_date;
      }
      return text;
    },
    getClosedTodolistText(todolist) {
      let text = todolist.creator;
      if(todolist.completed_date) {
        text += ' completed on ' + todolist.completed_date;
      }
      return text;
    },
  },
};
</script>